import { useMatch } from "react-router";

export const useIsSquadRoute = () => {
  const onSquadSelection = useMatch("/squad-selection");
  const onTransfers = useMatch("/transfers");
  return Boolean(onSquadSelection || onTransfers);
};
